module.exports = __webpack_public_path__ + "img/woocommerce-logo.185e1054.svg";